import { MatDialog, MatDialogRef } from "@angular/material/dialog";

import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  Optional,
} from "@angular/core";
import { UserserviceService } from "src/app/Services/userservice.service";
import { Router } from "@angular/router";
import { DataService } from "src/app/Services/dataservice.service";
import { CdkDragDrop, moveItemInArray } from "@angular/cdk/drag-drop";
import { HttpClient, HttpEvent, HttpEventType } from "@angular/common/http";
import { ShowFlowImageDialogComponent } from "../show-flow-image-dialog/show-flow-image-dialog.component";
import { environment } from "src/environments/environment";
import { url } from "inspector";
import { MatAutocompleteSelectedEvent } from "@angular/material/autocomplete";
import { ItemLibraryService, ItemLibraryModel } from "src/app/Services/item-library.service";
import { MediaUploadService } from "src/app/Services/media-upload.service";
import { debounceTime, distinctUntilChanged, switchMap, catchError } from "rxjs/operators";
import { of, Subject } from "rxjs";

@Component({
  selector: "app-items",
  templateUrl: "./items.component.html",
  styleUrls: ["./items.component.scss"],
})
export class ItemsComponent implements OnInit {
  showNotificationCount: boolean;
  notificationCount: number;
  profilePicture: string;
  userDisplayName: any;
  userData: any;
  showDefaultImage: boolean;
  email: any;
  phone: any;
  info: any;
  website: any;
  uname: any;
  name: any;
  flows: any;
  iname: string;
  itemsRequired: any[];
  quantity: string;
  fileData: File = null;
  noResultReturned: boolean;
  fileName: string;
  Url: string;
  isStepCoverPageURISet: boolean;
  showImage: boolean;
  showVideo: boolean;
  wheretofindit: any;
  progress: number = 0;
  groupName: string;
  groupedItems: { [key: string]: any[] } = {};
  groupList: string[] = []; // List of options
  groupedData: Record<string, any[]> = {};
  itemsRequiredCopy: any[];
  
  // Library integration
  libraryGroupSuggestions: ItemLibraryModel[] = [];
  libraryItemSuggestions: ItemLibraryModel[] = [];
  groupNameInput$ = new Subject<string>();
  itemNameInput$ = new Subject<string>();
  selectedLibraryItem: ItemLibraryModel = null;

  @Input() embedded: boolean = false;
  @Output() closeEmbedded = new EventEmitter<void>();

  constructor(
    private userserviceService: UserserviceService,
    private dataService: DataService,
    private router: Router,
    private http: HttpClient,
    private dialog: MatDialog,
    private itemLibraryService: ItemLibraryService,
    private mediaUploadService: MediaUploadService,
    @Optional() public dialogRef?: MatDialogRef<ItemsComponent>
  ) {}

  ngOnInit(): void {
    this.userData = JSON.parse(localStorage.getItem("LoggedInUser"));
    this.showNotificationCount = false;
    this.notificationCount = 4;

    if (this.userData != null) {
      this.userDisplayName = this.userData.firstName;
    }

    this.dataService.setFlowByCategorieschangeMessage.subscribe((flowData) => {
      this.flows = flowData;
      this.flows = JSON.parse(localStorage.getItem("flowByCategory"));
    });

    this.itemsRequired = JSON.parse(localStorage.getItem("ItemsRequired"));
    if (this.itemsRequired == null) {
      this.itemsRequired = [];
    } else {
      this.groupDataByGroupName();
    }
    console.log(this.itemsRequired);
    this.getProfileUser();
    this.setupLibrarySearch();
    // this.groupItems();
  }

  setupLibrarySearch() {
    // Search library when group name is typed
    this.groupNameInput$.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      switchMap((term: string) => {
        if (term && term.length >= 2) {
          return this.itemLibraryService.searchItemLibraries({ groupName: term });
        }
        return of([]);
      }),
      catchError(() => of([]))
    ).subscribe((results: ItemLibraryModel[]) => {
      this.libraryGroupSuggestions = results;
      // Update groupList with library suggestions
      const libraryGroups = [...new Set(results.map(r => r.groupName).filter(g => g))];
      this.groupList = [...new Set([...this.groupList, ...libraryGroups])];
    });

    // Search library when item name is typed
    this.itemNameInput$.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      switchMap((term: string) => {
        if (term && term.length >= 2) {
          return this.itemLibraryService.searchItemLibraries({ itemName: term });
        }
        return of([]);
      }),
      catchError(() => of([]))
    ).subscribe((results: ItemLibraryModel[]) => {
      this.libraryItemSuggestions = results;
    });
  }

  onGroupNameInput(value: string) {
    this.groupNameInput$.next(value);
  }

  onItemNameInput(value: string) {
    this.itemNameInput$.next(value);
  }

  selectLibraryItem(item: ItemLibraryModel) {
    this.selectedLibraryItem = item;
    this.groupName = item.groupName;
    this.iname = item.itemName;
    this.wheretofindit = item.link;
    if (item.imageUrl) {
      this.Url = item.imageUrl;
      this.showImage = true;
      this.showVideo = false;
    }
  }

  groupDataByGroupName() {
    if (!this.itemsRequired || this.itemsRequired.length === 0) {
      this.groupedData = {}; // Ensure no errors on empty or undefined data
      return;
    }

    this.groupedData = this.itemsRequired.reduce((acc, item) => {
      const group = item.groupName || ""; // Default group if missing
      if (!acc[group]) {
        acc[group] = [];
      }
      acc[group].push(item);
      return acc;
    }, {} as Record<string, any[]>);

    this.getAllGroupName();
  }
  removePicture() {
    this.Url = null;
  }

  drop(event: CdkDragDrop<any[]>) {
    if (!event.item.data) return;

    const previousGroup = event.previousContainer.id;
    const newGroup = event.container.id;
    const item = event.item.data;

    if (previousGroup !== newGroup) {
      // Remove item from old group
      this.groupedData[previousGroup] = this.groupedData[previousGroup].filter(
        (i) => i !== item
      );

      // Update the item with new group information (optional)
      item.groupName = newGroup;

      // Add item to new group
      if (!this.groupedData[newGroup]) {
        this.groupedData[newGroup] = [];
      }
      this.groupedData[newGroup].push(item);
    } else {
      // Reorder within the same group
      moveItemInArray(
        this.groupedData[newGroup],
        event.previousIndex,
        event.currentIndex
      );
    }
  }

  getAllDropListIds(): string[] {
    return Object.keys(this.groupedData);
  }

  close() {
    localStorage.setItem("ItemsRequired", JSON.stringify(this.itemsRequired));
    this.handleCloseRequest();
  }

  addItems() {
    var editItemsRequiredIndex = localStorage.getItem("editItemsRequiredIndex");

    if (editItemsRequiredIndex != null) {
      this.itemsRequired.splice(parseInt(editItemsRequiredIndex), 1);
    }

    const newItem = {
      groupName: this.groupName,
      itemkey: this.iname,
      itemValue: this.quantity,
      url: this.Url,
      wheretofindit: this.wheretofindit,
    };

    // If this is from library and user modified values, create override
    if (this.selectedLibraryItem && this.userData) {
      const hasChanges = 
        this.wheretofindit !== this.selectedLibraryItem.link ||
        this.Url !== this.selectedLibraryItem.imageUrl;
      
      if (hasChanges) {
        // Create user override
        this.itemLibraryService.createOrUpdateUserOverride({
          libraryItemRowKey: this.selectedLibraryItem.rowKey,
          userEmail: this.userData.emailAddress,
          groupName: this.groupName,
          itemName: this.iname,
          link: this.wheretofindit,
          imageUrl: this.Url,
          isPrivate: true
        }).subscribe(
          () => console.log("User override created"),
          (error) => console.error("Error creating override:", error)
        );
      }
    }

    this.itemsRequired.push(newItem);

    if (this.groupName && !this.groupList.includes(this.groupName.trim())) {
      this.groupList.push(this.groupName.trim()); // Add only if it's unique
    }
    this.iname = "";
    this.quantity = "";
    this.Url = "";
    this.wheretofindit = "";
    this.selectedLibraryItem = null;
    // localStorage.setItem("ItemsRequired", JSON.stringify(this.itemsRequired));
    localStorage.removeItem("editItemsRequiredIndex");
    this.groupDataByGroupName();
  }

  getAllGroupName() {
    if (this.itemsRequired && this.itemsRequired.length > 0) {
      // Ensure groups exist
      this.itemsRequired.forEach((element) => {
        if (element.groupName) {
          const trimmedGroup = element.groupName.trim();
          if (trimmedGroup && !this.groupList.includes(trimmedGroup)) {
            this.groupList.push(trimmedGroup); // Add only if unique
          }
        }
      });
    }

    console.log(this.groupList);
  }
  editItems(index, item) {
    this.showImage = true;
    this.groupName = item.groupName;
    this.iname = item.itemkey;
    this.quantity = item.itemValue;
    this.Url = item.url;
    this.wheretofindit = item.wheretofindit;
    console.log(item.url);
    localStorage.setItem("editItemsRequiredIndex", index);
  }

  createFlow() {
    this.handleCloseRequest();
  }

  done() {
    localStorage.setItem("ItemsRequired", JSON.stringify(this.itemsRequired));
    this.handleCloseRequest();
  }

  getProfileUser(): void {
    if (this.userData != null) {
      this.showNotificationCount = true;

      this.userserviceService.getProfileUser().subscribe((data) => {
        if (
          data.userData.profilePicUrl === "" ||
          data.userData.profilePicUrl == null
        ) {
          this.showDefaultImage = true;
        } else {
          this.showDefaultImage = false;
          this.profilePicture = data.userData.profilePicUrl;
        }
        this.email = data.userData.emailAddress;
        this.phone = data.userData.phoneNumber;
        this.info = data.userData.info;
        this.website = data.userData.website;
        this.uname = data.userData.userName;
        this.name = data.userData.firstName;
      });
    }
  }

  openLink(url) {
    url = "https://" + url;
    window.open(url);
  }

  SignOut() {
    localStorage.setItem("LoggedInUser", null);
    this.userDisplayName = null;
    this.router.navigate(["/"]);
  }

  remove(index, item) {
    const indexToDelete = this.itemsRequired.indexOf(item);
    this.itemsRequired.splice(indexToDelete, 1);
    this.groupDataByGroupName();
  }

  checkLoggedIn() {
    if (this.userData === null) {
      this.router.navigate(["/login"], {
        queryParams: { returnUrl: this.router.url },
      });
    } else {
      this.router.navigate(["/create-guide"]);
    }
  }

  checkIsUserLoggedIn() {
    if (this.userData === null) {
      this.router.navigate(["/login"], {
        queryParams: { returnUrl: this.router.url },
      });
    }
  }

  async selectFiles(event) {
    if (event.target.files) {
      this.noResultReturned = true;
      this.fileData = <File>event.target.files[0];
      this.fileName = this.fileData.name;
      this.isStepCoverPageURISet = true;

      // Add progress property if not already in your class
      // public progress: number = 0;
      // File type detection
      const imageExtensions = [
        "jpeg",
        "jpg",
        "png",
        "gif",
        "jfif",
        "tiff",
        "tif",
        "pdf", // From your list, normalized
        "bmp",
        "webp",
        "svg",
        "heic",
        "heif",
        "raw",
        "arw",
        "cr2",
        "nef",
        "orf",
        "rw2",
        "dng",
        "psd",
        "ico",
        "exif",
        "pjpeg",
        "ppm",
        "pgm",
        "pbm",
        "pnm",
        "xpm",
        "tga",
        "pcx",
        "jp2",
        "jpx",
        "eps",
        "ai",
      ];
      const videoExtensions = [
        "mp4",
        "mov",
        "wmv",
        "flv",
        "avchd",
        "webm",
        "mkv",
        "vob", // From your list
        "ogv",
        "gifv",
        "m4p",
        "m4v",
        "3gp",
        "3g2",
        "amv",
        "nsv",
        "ogg",
        "f4v",
        "f4p",
        "f4a",
        "f4b", // From your list
        "avi",
        "mts",
        "m2ts",
        "ts",
        "mpg",
        "mpeg",
        "rm",
        "rmvb",
        "divx",
        "xvid",
        "asf",
        "mxf",
        "dv",
        "h264",
        "h265",
        "vp8",
        "vp9",
        "prores",
        "swf",
        "dat",
        "bik",
        "av1",
        "vro",
        "svi",
      ];

      const isImage = imageExtensions.some((ext) =>
        this.fileData.name.includes(ext)
      );
      const isVideo = videoExtensions.some((ext) =>
        this.fileData.name.includes(ext)
      );

      let fileToUpload = this.fileData;
      if (isVideo) {
        try {
          fileToUpload = await this.mediaUploadService.prepareFileForUpload(this.fileData);
          this.fileData = fileToUpload;
        } catch (error: any) {
          this.noResultReturned = false;
          this.isStepCoverPageURISet = false;
          alert(error?.message || this.mediaUploadService.uploadTooLargeMessage());
          return;
        }
      }

      const formData = new FormData();
      formData.append("fileData", fileToUpload);

      const uploadUrl = isImage
        ? environment.apiBaseUrl + environment.uploadImageUrl
        : environment.apiBaseUrl + environment.uploadVideoUrl;

      if (isImage || isVideo) {
        this.http
          .post(uploadUrl, formData, {
            reportProgress: true,
            observe: "events",
          })
          .subscribe(
            (event: HttpEvent<any>) => {
              switch (event.type) {
                case HttpEventType.UploadProgress:
                  if (event.total) {
                    this.progress = Math.round(
                      (event.loaded / event.total) * 100
                    );
                  }
                  break;

                case HttpEventType.Response:
                  const mediaUploadStatus = event.body as any;
                  this.noResultReturned = false;

                  if (mediaUploadStatus != null) {
                    if (isImage) {
                      this.showImage = true;
                      this.showVideo = false;
                      this.Url =
                        environment.imageStorageBaseUrl +
                        mediaUploadStatus.fileName;
                    } else if (isVideo) {
                      this.showVideo = true;
                      this.showImage = false;
                      this.Url =
                        environment.videoStorageBaseUrl +
                        mediaUploadStatus.fileName;
                    }
                  } else {
                    alert(mediaUploadStatus.message);
                  }
                  break;
              }
            },
            (error) => {
              this.noResultReturned = false;
              this.isStepCoverPageURISet = false;
              alert(this.mediaUploadService.uploadTooLargeMessage());
              console.error("Upload error:", error);
            }
          );
      }
    }
  }

  private handleCloseRequest() {
    if (this.embedded) {
      this.closeEmbedded.emit();
    } else if (this.dialogRef) {
      this.dialogRef.close(true);
    } else {
      this.router.navigate(["/create-guide"]);
    }
  }

  openImage(Url) {
    localStorage.setItem("itemsRequiredImageToShow", Url);
    console.log(Url);
    this.dialog.open(ShowFlowImageDialogComponent, {
      panelClass: ["media-dialog-pane", "media-dialog"],
      backdropClass: "custom-backdrop",
      maxWidth: "95vw",
      width: "auto",
      maxHeight: "95vh",
      height: "auto",
      autoFocus: false,
      restoreFocus: false,
    });
  }

  onSelectGroup(event: MatAutocompleteSelectedEvent) {
    this.groupName = event.option.value; // Update the input with the selected value
    // If a library item was selected, load its details
    const selectedItem = this.libraryGroupSuggestions.find(
      item => item.groupName === event.option.value
    );
    if (selectedItem) {
      this.selectLibraryItem(selectedItem);
    }
  }
}
